import { render } from "./ListGroup.vue?vue&type=template&id=6a12d772&scoped=true&ts=true"
import script from "./ListGroup.vue?vue&type=script&lang=ts"
export * from "./ListGroup.vue?vue&type=script&lang=ts"

import "./ListGroup.vue?vue&type=style&index=0&id=6a12d772&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a12d772"]])

export default __exports__